import React, { useCallback, useState } from "react";
import { Button, Modal } from "antd";
import { ButtonHTMLType } from "antd/lib/button/button";
import { inject, observer } from "mobx-react";
import { CREATE_CMR } from "../../../constants/translates";
import CreateCmrForm from "../../forms/CmrForm/createCmr";
import {
  CAN_CREATE_AND_EDIT_CMR,
  ROLE_CLIENT,
} from "../../../constants/authorize";
import Authorize from "../../Authorize";
import DisabledButton from "./disabledButton";
import { IAppStore } from "../../../stores/Interfaces";
import { generate } from "../../../helpers/hash";

interface Props {
  store?: IAppStore;
  buttonHtmlType?: ButtonHTMLType;
  modalFooter?: React.ReactNode;
}

const NO_DEPARTMENT = "No Department";

const CreateCmr: React.FC<Props> = ({ buttonHtmlType, modalFooter, store }) => {
  const [modalVisibility, setModalVisibility] = useState<boolean>(false);

  const showModal = useCallback(() => {
    setModalVisibility(true);
  }, []);

  const hideModal = useCallback(() => {
    setModalVisibility(false);
  }, []);

  const user = store?.userStore.user;

  const modalForm = (
    <>
      <Button
        type="primary"
        size="small"
        htmlType={buttonHtmlType}
        onClick={showModal}
      >
        {CREATE_CMR}
      </Button>

      <Modal
        visible={modalVisibility}
        footer={modalFooter}
        onCancel={hideModal}
        title={CREATE_CMR}
        cancelButtonProps={{
          onClick: hideModal,
        }}
        className="xl"
      >
        <CreateCmrForm
          onFinish={hideModal}
          clientId={
            store?.userStore.authorizeByRole(ROLE_CLIENT) && user
              ? (user.id as number)
              : undefined
          }
          departmentId={
            store?.userStore.authorizeByRole(ROLE_CLIENT) && user
              ? (user.department_id as number | null)
              : undefined
          }
          clients={store?.settingsStore.clients || []}
          departments={store?.settingsStore.departments || []}
          countries={store?.countryStore.asOptions || []}
          hash={generate()}
        />
      </Modal>
    </>
  );

  if (user && user.department_id === null) {
    return (
      <Authorize
        permission={CAN_CREATE_AND_EDIT_CMR}
        deniedComponent={<DisabledButton message={NO_DEPARTMENT} />}
      >
        {modalForm}
      </Authorize>
    );
  }

  return (
    <Authorize permission={CAN_CREATE_AND_EDIT_CMR}>{modalForm}</Authorize>
  );
};

export default inject("store")(observer(CreateCmr));
